<form [formGroup]="formGroup">
  <legend class="section-sub-label">Employment Details</legend>
  <div fxLayout="row" fxLayoutGap="20px">
    <div class="ddlbHeightFix" fxLayout="column" fxLayoutAlign="end start">
      <mat-label>Primary Source of Income
      </mat-label>
      <div class="form-input">
        <mat-form-field appearance="outline" id="mff_incomeSource">
          <mat-select [aria-label]="isPrimary ? 'Primary applicant primary source of income' : 'Co-applicant primary source of income'" [compareWith]="compareValueWithSelection" formControlName="incomeSource" id="incomeSource"
                      matInput

          >
            <mat-option [value]="0">--Select--</mat-option>
            <mat-option *ngFor="let curSource of incomeSourceList" [value]="curSource.incomeSourceId">
              {{curSource.incomeSourceName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>

    <div class="ddlbHeightFix" fxLayout="column" fxLayoutAlign="end start">
      <mat-label>
        Occupation
      </mat-label>
      <div class="form-input">
        <mat-form-field appearance="outline" id="mff_occupation">
          <mat-select [aria-label]="isPrimary ? 'Primary applicant occupation' : 'Co-applicant occupation'" [compareWith]="compareValueWithSelection" formControlName="occupation" id="occupation"
                      matInput

          >
            <mat-option [value]="0">--Select--</mat-option>
            <mat-option *ngFor="let curOccupation of occupationList" [value]="curOccupation.occupationId">
              {{curOccupation.occupationName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="20px">
    <div fxLayout="column" fxLayoutAlign="end start">
      <mat-label>Employer Country
      </mat-label>
      <div class="form-input">
        <mat-form-field appearance="outline" id="mff_employerCountry">

          <mat-select [aria-label]="isPrimary ? 'Primary applicant employer country' : 'Co-applicant employer country'" [compareWith]="compareValueWithSelection" formControlName="employerCountry" id="employerCountry"
                      matInput

          >
            <mat-option [value]="0">--Select--</mat-option>
            <mat-option *ngFor="let curCountry of employerCountryList"
                        [value]="curCountry.countryId">{{curCountry.countryName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="end start">
      <mat-label>Annual Income
      </mat-label>
      <div class="form-input">
        <mat-form-field appearance="outline" id="mff_annualIncome">

          <mat-select [aria-label]="isPrimary ? 'Primary applicant annual income' : 'Co-applicant annual income'" [compareWith]="compareValueWithSelection" formControlName="annualIncome" id="annualIncome"
                      matInput

          >
            <mat-option [value]="0">--Select--</mat-option>
            <mat-option *ngFor="let curAnnualIncome of annualIncomeList" [value]="curAnnualIncome.annualIncomeId">
              {{curAnnualIncome.displayValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
